import { API_URL_FACTORY } from '@factories/apiUrlFactory'

export const fetchDeepLink = async regNo => {
  try {
    const downloadApi = API_URL_FACTORY.DEPP_LINK_API(regNo)
    const response = await fetch(downloadApi)

    const data = await response.json()
    if (data?.success && data?.data?.url) {
      return data?.data?.url
    }
  } catch (e) {
    console.error('error fetching deep link', e)
  }
}
